import {Component} from "react";
import React from "react";
import {Link} from "react-router-dom";

class CartChangeQty extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <span>
            <span>
                  <Link to={'quotation/edit/' + this.props.itemId}>
                 <label className="cart-change-font-mobile"> 数量変更</label>
                  </Link>
            </span>
            </span>
        );
    }

}

export default CartChangeQty;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartChangeQty/CartChangeQty.js